import PartnerCompanyPage from '@/features/companyDashboard/partners/PartnerCompanyPage';

const CompanyPage = () => <PartnerCompanyPage />;

export default CompanyPage;
